'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _aluminum = require('./aluminum.html');

var _aluminum2 = _interopRequireDefault(_aluminum);

var _metal = require('./metal.html');

var _metal2 = _interopRequireDefault(_metal);

var _plastic = require('./plastic.html');

var _plastic2 = _interopRequireDefault(_plastic);

var _wood = require('./wood.html');

var _wood2 = _interopRequireDefault(_wood);

var _acrylic = require('./acrylic.html');

var _acrylic2 = _interopRequireDefault(_acrylic);

var _led = require('./led.html');

var _led2 = _interopRequireDefault(_led);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  aluminium: _aluminum2.default,
  metal: _metal2.default,
  plastic: _plastic2.default,
  wood: _wood2.default,
  acrylic: _acrylic2.default,
  led: _led2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/templates/signs/index.js
 **/